/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Provider } from "~/generated/graphql";
import { SelectorOption, RuleType, AccountData } from "./types";

function mapAccounts(accounts: AccountData[] = []): SelectorOption[] {
  return accounts.map(
    ({ providerId, displayName, name, activated }): SelectorOption => ({
      value: providerId,
      label: displayName || name,
      icon: activated,
    })
  );
}

function filterAccount(account: AccountData, provider: Provider): boolean {
  return provider ? account.provider && provider === account.provider : true;
}

function getAccountsByProvider(accounts: AccountData[], provider: Provider) {
  return accounts.filter((account) => filterAccount(account, provider));
}

export function mapLabels(type: RuleType): string {
  switch (type) {
    case RuleType.CLOUD_ACCOUNT:
      return "Cloud Account";
    case RuleType.PROJECT_ID:
      return "Google Cloud Project ID";
    case RuleType.RESOURCE_GROUP:
      return "Resource Group (non-IBM Cloud)";
    case RuleType.IBM_RESOURCE_GROUP:
      return "Resource Group (IBM Cloud)";
    case RuleType.RESOURCE_TYPE:
      return "Resource Type";
    case RuleType.RESOURCE_TAGS:
      return "Tag";
    case RuleType.AWS_VPC:
      return "AWS VPC";
    case RuleType.SECURITY_GROUP_IDS:
      return "AWS Security Group";
    default:
      return "";
  }
}

export function getCloudAccounts(
  accounts: AccountData[] = []
): SelectorOption[] {
  return mapAccounts([
    ...getAccountsByProvider(accounts, Provider.Aws),
    ...getAccountsByProvider(accounts, Provider.Azure),
    ...getAccountsByProvider(accounts, Provider.Ibmcloud),
    ...getAccountsByProvider(accounts, Provider.Gcp).filter(
      // `Gcp` provider contains non-cloud accounts, filter is necessary
      (account) => account.providerType === "CLOUD"
    ),
    ...getAccountsByProvider(accounts, Provider.Hybrid),
  ]);
}
